import { createReducer } from '@reduxjs/toolkit';

import * as coursesActions from './coursesActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  sid: 0,
  type: 'courses',
  isAdded: false,
  isActive: false,

  courses: [],

  headingTitle: '',
  headingImage: '',
  headingTextAlign: 'left',
  headingDescription: '',
  headingDivider: '',

  sectionIsBackground: false,
  sectionTextColor: '#000000',
  sectionShadow: 'soft',
  sectionShadowColor: '#000',
  sectionShadowBorderColor: '#000',
  sectionBorderColor: '#000',
  sectionShape: 'round',
  sectionOpacity: 0,
  sectionBackgroundColor: '#ffffff',
  sectionIsFullWidth: false,
  sectionPadding: 20,
  sectionMargin: 12,
  sectionBackgroundType: 1,
  sectionBackgroundImage: '',
  sectionGradientColor1: '#B3F7EF',
  sectionGradientColor2: '#F7D6E0',
  sectionGradientDirection: 0,
  sectionGradientOffset: 0,
  sectionBorder: 'none',

  itemShadow: 'none',
  itemShadowColor: '#000',
  itemBorder: 'none',
  itemBorderColor: '#000',
  itemShape: 'round',
};

const courses = createReducer(initialState, (builder) => {
  builder
    .addCase(coursesActions.coursesStore, (state, { payload }) => {
      const { id, uid, sid, isAdded, isActive, data } = payload;

      const section = data ?? {};
      const {
        courses,

        headingTitle,
        headingDescription,
        headingImage,
        headingTextAlign,
        headingDivider,

        sectionBackgroundColor,
        sectionTextColor,
        sectionOpacity,
        sectionIsFullWidth,
        sectionShadow,
        sectionShadowColor,
        sectionShadowBorderColor,
        sectionPadding,
        sectionMargin,
        isSectionBackground,
        sectionBackgroundType,
        sectionBackgroundImage,
        sectionGradientColor1,
        sectionGradientColor2,
        sectionGradientDirection,
        sectionGradientOffset,
        sectionShape,
        sectionBorderColor,
        sectionBorder,

        itemShadow,
        itemShadowColor,
        itemShape,
        itemBorder,
        itemBorderColor,
      } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id: id ?? 0,
        uid: uid ?? 0,
        sid: sid ?? 0,
        isActive: isActive,
        isAdded: isAdded,

        courses: courses ?? [],

        headingTextAlign: headingTextAlign ?? 'left',
        headingTitle: headingTitle ?? '',
        headingDescription: headingDescription ?? '',
        headingImage: headingImage ?? '',
        headingDivider: headingDivider ?? '',

        sectionMargin: sectionMargin,
        sectionBackgroundColor: sectionBackgroundColor ?? '#ffffff',
        sectionTextColor: sectionTextColor ?? '#000000',
        sectionOpacity: sectionOpacity ?? 0,
        sectionIsFullWidth: sectionIsFullWidth ?? false,
        sectionShadow: sectionShadow ?? 'none',
        sectionShadowColor: sectionShadowColor ?? '#000',
        sectionPadding: sectionPadding,
        sectionIsBackground: isSectionBackground ?? false,
        sectionBackgroundType: sectionBackgroundType ?? 1,
        sectionBackgroundImage: sectionBackgroundImage ?? '',
        sectionGradientColor1: sectionGradientColor1 ?? '#B3F7EF',
        sectionGradientColor2: sectionGradientColor2 ?? '#F7D6E0',
        sectionGradientDirection: sectionGradientDirection ?? 0,
        sectionGradientOffset: sectionGradientOffset ?? 0,
        sectionShadowBorderColor: sectionShadowBorderColor ?? '#000',
        sectionBorderColor: sectionBorderColor ?? '#000',
        sectionShape: sectionShape ?? 'round',
        sectionBorder: sectionBorder ?? 'none',

        itemShadow: itemShadow ?? 'none',
        itemShadowColor: itemShadowColor ?? '#000',
        itemShape: itemShape ?? 'round',
        itemBorder: itemBorder ?? 'none',
        itemBorderColor: itemBorderColor ?? '#000',
      };
    })

    .addCase(coursesActions.coursesUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(coursesActions.coursesUpdateIsAdded, (state, { payload: isAdded }) => ({ ...state, isAdded }))
    .addCase(coursesActions.coursesUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(coursesActions.coursesUpdateRequesting, (state, { payload }) => ({ ...state, requesting: payload, error: null }))
    .addCase(coursesActions.coursesUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(coursesActions.coursesUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(coursesActions.coursesUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(coursesActions.coursesUpdateHeadingTitle, (state, { payload: headingTitle }) => ({ ...state, headingTitle }))
    .addCase(coursesActions.coursesUpdateHeadingDescription, (state, { payload: headingDescription }) => ({ ...state, headingDescription }))
    .addCase(coursesActions.coursesUpdateHeadingTextAlign, (state, { payload: headingTextAlign }) => ({ ...state, headingTextAlign }))
    .addCase(coursesActions.coursesUpdateHeadingImage, (state, { payload: headingImage }) => ({ ...state, headingImage }))
    .addCase(coursesActions.coursesUpdateHeadingDivider, (state, { payload: headingDivider }) => ({ ...state, headingDivider }))

    .addCase(coursesActions.coursesUpdateSectionIsBackground, (state, { payload: sectionIsBackground }) => ({ ...state, sectionIsBackground }))
    .addCase(coursesActions.coursesUpdateSectionTextColor, (state, { payload: sectionTextColor }) => ({ ...state, sectionTextColor }))
    .addCase(coursesActions.coursesUpdateSectionBackgroundColor, (state, { payload: sectionBackgroundColor }) => ({ ...state, sectionBackgroundColor }))
    .addCase(coursesActions.coursesUpdateSectionOpacity, (state, { payload: sectionOpacity }) => ({ ...state, sectionOpacity }))
    .addCase(coursesActions.coursesUpdateSectionIsFullWidth, (state, { payload: sectionIsFullWidth }) => ({ ...state, sectionIsFullWidth }))
    .addCase(coursesActions.coursesUpdateSectionShadow, (state, { payload: sectionShadow }) => ({ ...state, sectionShadow }))
    .addCase(coursesActions.coursesUpdateSectionShadowColor, (state, { payload: sectionShadowColor }) => ({ ...state, sectionShadowColor }))
    .addCase(coursesActions.coursesUpdateSectionPadding, (state, { payload: sectionPadding }) => ({ ...state, sectionPadding }))
    .addCase(coursesActions.coursesUpdateSectionMargin, (state, { payload: sectionMargin }) => ({ ...state, sectionMargin }))
    .addCase(coursesActions.coursesUpdateSectionBackgroundType, (state, { payload: sectionBackgroundType }) => ({ ...state, sectionBackgroundType }))
    .addCase(coursesActions.coursesUpdateSectionBackgroundImage, (state, { payload: sectionBackgroundImage }) => ({ ...state, sectionBackgroundImage }))
    .addCase(coursesActions.coursesUpdateSectionGradientColor1, (state, { payload: sectionGradientColor1 }) => ({ ...state, sectionGradientColor1 }))
    .addCase(coursesActions.coursesUpdateSectionGradientColor2, (state, { payload: sectionGradientColor2 }) => ({ ...state, sectionGradientColor2 }))
    .addCase(coursesActions.coursesUpdateSectionGradientDirection, (state, { payload: sectionGradientDirection }) => ({ ...state, sectionGradientDirection }))
    .addCase(coursesActions.coursesUpdateSectionGradientOffset, (state, { payload: sectionGradientOffset }) => ({ ...state, sectionGradientOffset }))
    .addCase(coursesActions.coursesUpdateSectionShadowBorderColor, (state, { payload: sectionShadowBorderColor }) => ({ ...state, sectionShadowBorderColor }))
    .addCase(coursesActions.coursesUpdateSectionBorderColor, (state, { payload: sectionBorderColor }) => ({ ...state, sectionBorderColor }))
    .addCase(coursesActions.coursesUpdateSectionShape, (state, { payload: sectionShape }) => ({ ...state, sectionShape }))
    .addCase(coursesActions.coursesUpdateSectionBorder, (state, { payload: sectionBorder }) => ({ ...state, sectionBorder }))

    .addCase(coursesActions.coursesUpdateItemShadow, (state, { payload: itemShadow }) => ({ ...state, itemShadow }))
    .addCase(coursesActions.coursesUpdateItemShadowColor, (state, { payload: itemShadowColor }) => ({ ...state, itemShadowColor }))
    .addCase(coursesActions.coursesUpdateItemShape, (state, { payload: itemShape }) => ({ ...state, itemShape }))
    .addCase(coursesActions.coursesUpdateItemBorder, (state, { payload: itemBorder }) => ({ ...state, itemBorder }))
    .addCase(coursesActions.coursesUpdateItemBorderColor, (state, { payload: itemBorderColor }) => ({ ...state, itemBorderColor }))

    .addCase(coursesActions.coursesUpdateCourses, (state, { payload: courses }) => ({ ...state, courses }));
});

export default courses;
